import requester from '@/lib/axios';
import {
  DNDPositionalQuestion,
  PositionalQuestionCreateDTO,
} from '@/models/Question';

const baseUrl = 'dnd-positional-activity';

export const getPositionalQuestion = async (id: number) => {
  const { data } = await requester().get<DNDPositionalQuestion>(
    `${baseUrl}/${id}/`,
  );
  return data;
};

export const createPositionalQuestion = async (
  body: Partial<PositionalQuestionCreateDTO>,
) => {
  const { data } = await requester().post<DNDPositionalQuestion>(
    `${baseUrl}/`,
    body,
  );
  return data;
};

export const updatePositionalQuestion = async (
  id: number,
  changes: Partial<
    Pick<PositionalQuestionCreateDTO, 'title' | 'context' | 'feedbacks'>
  >,
) => {
  const { data } = await requester().patch<DNDPositionalQuestion>(
    `${baseUrl}/${id}/`,
    changes,
  );
  return data;
};

export const deletePositionalQuestion = async (id: number) => {
  await requester().delete(`${baseUrl}/${id}/`);
};
